// Ported from design/project/App19-Draw.dc.html, then wired to the settled battle.
import { fmtPrice } from "../format.js";
import { cardInitials, displayName, useGame, usePlayer } from "../game.js";
import { useRematch } from "./Rematch.js";
import { LevelUp, useBattleXp, xpLabel } from "./Xp.js";

export function App19_Draw() {
  const { battle, mySide } = useGame();
  const long = usePlayer(battle?.long);
  const short = usePlayer(battle?.short);
  const again = useRematch(battle, displayName(mySide === "long" ? short : long, "Your opponent"));
  const xp = useBattleXp(battle?.id);
  if (!battle) return null;
  return (
    <>
      <div className="screen dots">
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="row tgbar">
      
      <span className="tag tagW">DUEL #{battle.id.slice(0, 4).toUpperCase()}</span>
    </div>

    <div style={{ marginTop: "50px", display: "flex", alignItems: "center", justifyContent: "center", gap: "18px" }}>
      <div className="avA" style={{ width: "84px", height: "84px", borderRadius: "20px", borderWidth: "3px", background: "#CCFF00", fontSize: "24px", transform: "rotate(-6deg)", boxShadow: "5px 5px 0 #000" }}>{cardInitials(long)}</div>
      <svg width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true"><path d="M5 9h14M5 15h14"></path></svg>
      <div className="avA" style={{ width: "84px", height: "84px", borderRadius: "20px", borderWidth: "3px", background: "#FF3366", fontSize: "24px", transform: "rotate(6deg)", boxShadow: "5px 5px 0 #000" }}>{cardInitials(short)}</div>
    </div>

    <div style={{ marginTop: "36px", alignSelf: "center", transform: "skewX(-8deg)", animation: "ddPop 1.6s infinite" }}>
      <div className="big" style={{ fontSize: "64px", color: "#FFFFFF", textShadow: "4px 4px 0 #0B0E14, 8px 8px 0 #8B949E" }}>DRAW!</div>
    </div>
    <span className="unb" style={{ marginTop: "16px", alignSelf: "center", fontWeight: "800", fontSize: "12px", letterSpacing: "0.16em" }}>NOBODY BLINKED</span>

    <div className="panel" style={{ marginTop: "30px", padding: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <div className="row"><span className="muted" style={{ fontSize: "13px" }}>Entry price</span><span className="mono" style={{ fontWeight: "800", fontSize: "14px" }}>{fmtPrice(battle.arena, Number(battle.startPrice))}</span></div>
      <div className="row"><span className="muted" style={{ fontSize: "13px" }}>Final price</span><span className="mono" style={{ fontWeight: "800", fontSize: "14px" }}>{fmtPrice(battle.arena, Number(battle.endPrice))}</span></div>
      <div style={{ height: "2px", background: "#30363D" }}></div>
      <div className="row"><span style={{ fontSize: "14px", fontWeight: "700" }}>Your stake returned</span><span className="mono lime" style={{ fontWeight: "800", fontSize: "18px" }}>{battle.stake} USDT</span></div>
      <div className="row"><span className="muted" style={{ fontSize: "13px" }}>XP</span><span className="mono lime" style={{ fontWeight: "800", fontSize: "14px" }}>{xpLabel(xp)}</span></div>
      <span className="muted" style={{ fontSize: "12px" }}>Full refund to both sides. No rake taken on a draw.</span>
    </div>

    <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: "16px" }}>
      <button className="btnA" disabled={again.busy} onClick={() => void again.tap()}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B0E14" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"></path><path d="M3 3v6h6"></path></svg>
        {again.label ?? "RUN IT BACK"}
      </button>
      <a href="#/App09" className="btnAS" style={{ textDecoration: "none" }}>BACK TO LOBBY</a>
    </div>
  </div>
</div>
      {again.sheet}
      <LevelUp battleId={battle.id} x={xp} />
    </>
  );
}
